import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Component from './component'
import { submit } from '../../redux/modules/unlockEstateAddress'

const WithData = connect(
  state => ({
    courtagepflichtig:
      state.estatePage.estateData.additionals.courtagepflichtig,
    objektnr: state.estatePage.estateData.shortInfo.objektnr_extern.value,
    error: state.unlockEstateAddress.error,
    success: state.unlockEstateAddress.success,
    isSubmitting: state.unlockEstateAddress.isSubmitting,
  }),
  dispatch => bindActionCreators({ submit }, dispatch)
)(Component)

export default WithData
